import {AxiosObservable} from "axios-observable/dist/axios-observable.interface";
import {Pagination} from "@/models/sit-pedido/pagination";
import {Lote} from "@/models/sie-pedidos/lote";
import {DadosFilterLotes, PaginationTableLotes} from "@/store/modules/sie-pedidos/states/tableLotes";
import {GraficaApi} from "@/api/sie-pedidos/grafica.api";

const api = new GraficaApi();

const getListaLotes = (input: PaginationTableLotes): AxiosObservable<Pagination<Lote>> => {
  return api.getListaLotes(input);
};

const getDadosFilterGrafica = (): AxiosObservable<DadosFilterLotes> =>{
  return api.getDadosFilterGrafica()
};

const downloadLote = (id: number): AxiosObservable<Blob> => {
  return api
    .downloadLote(id)
}

const enviarLoteSindionibus = (idLote: number): AxiosObservable<any>=>{
  return api.enviarLoteSindionibus(idLote)
}

export default {
  getListaLotes,
  getDadosFilterGrafica, downloadLote,
  enviarLoteSindionibus
}
